/* ══════════════════════════════════════════════════════════
   ELLIE'S BARK BITES — shared behaviour
   Loaded from <head> with defer, so it is isolated from Shopify's
   per-section JS bundle (§5.6) and every control is wired by
   document-level delegation, surviving shopify:section:load.
   ══════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var routes = (window.Shopify && window.Shopify.routes) || {};
  var EBB = window.EBB = window.EBB || {};

  function safe(name, fn) {
    try { fn(); } catch (e) { if (window.console) console.warn('[ebb] ' + name, e); }
  }
  function on(type, sel, fn) {
    document.addEventListener(type, function (e) {
      var t = e.target && e.target.closest ? e.target.closest(sel) : null;
      if (t) fn(e, t);
    }, type === 'submit' ? false : undefined);
  }
  function money(cents) {
    if (typeof cents !== 'number') cents = parseInt(cents, 10) || 0;
    var fmt = (window.Shopify && window.Shopify.moneyFormat) || '${{amount}}';
    var v = cents / 100;
    function num(dec, sep, group) {
      var parts = v.toFixed(dec).split('.');
      var i = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, group || ',');
      return parts[1] ? i + (sep || '.') + parts[1] : i;
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, k) {
      switch (k) {
        case 'amount': return num(2, '.', ',');
        case 'amount_no_decimals': return num(0, '.', ',');
        case 'amount_with_comma_separator': return num(2, ',', '.');
        case 'amount_no_decimals_with_comma_separator': return num(0, ',', '.');
        case 'amount_with_space_separator': return num(2, ',', ' ');
        case 'amount_no_decimals_with_space_separator': return num(0, ',', ' ');
        case 'amount_with_period_and_space_separator': return num(2, '.', ' ');
        default: return num(2, '.', ',');
      }
    });
  }
  EBB.money = money;

  /* ══════════ TOAST ══════════ */
  var toastEl, toastTimer;
  function toast(msg, isErr) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'ebb ebb-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      toastEl.innerHTML = '<i class="fa-solid fa-circle-check" aria-hidden="true"></i> <span></span>';
      document.body.appendChild(toastEl);
    }
    toastEl.classList.toggle('is-err', !!isErr);
    toastEl.querySelector('i').className = isErr
      ? 'fa-solid fa-circle-exclamation' : 'fa-solid fa-circle-check';
    toastEl.querySelector('span').textContent = msg;
    // force a frame so the transition always runs
    void toastEl.offsetWidth;
    toastEl.classList.add('on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('on'); }, 2800);
  }
  EBB.toast = toast;

  /* ══════════ HEADER: sticky state + announcement height ══════════ */
  /* The rotator's messages are position:absolute so they can crossfade, which
     means they contribute nothing to their parent's height — the track has to
     carry an explicit one. That was hardcoded at 48px for a phone, tall enough
     for three lines when every message actually fits one, so the bar stood at
     60px and pushed the whole page down. Measure the tallest message at the
     real track width and let the track be exactly that. */
  function measureAnnoTrack(anno) {
    var track = anno.querySelector('.anno-track');
    var items = $$('.anno-item', anno);
    if (!track || !items.length) return;
    var w = Math.round(track.getBoundingClientRect().width);
    if (!w) return;

    /* Clone the real nodes rather than rebuilding their styling on a bare div.
       The item's display, gap, padding and font all come from CSS that changes
       at the breakpoint, and a probe that reconstructs some of it will measure
       one line where the live element wraps to two. A clone inherits all of it
       by definition — it only has to be taken out of the absolute flow. */
    var holder = document.createElement('div');
    holder.style.cssText = 'position:absolute;visibility:hidden;left:-9999px;top:0;width:' + w + 'px;';
    anno.appendChild(holder);
    var tallest = 0;
    items.forEach(function (el) {
      var c = el.cloneNode(true);
      c.classList.remove('is-on');
      c.style.cssText = 'position:static;opacity:1;transform:none;height:auto;inset:auto;';
      holder.appendChild(c);
      tallest = Math.max(tallest, c.getBoundingClientRect().height);
      holder.removeChild(c);
    });
    holder.remove();
    if (tallest > 0) anno.style.setProperty('--anno-track-h', Math.ceil(tallest) + 'px');
  }

  function measureAnno() {
    var anno = $('.ebb-anno');
    if (anno) safe('annotrack', function () { measureAnnoTrack(anno); });
    var h = anno ? Math.round(anno.getBoundingClientRect().height) : 0;
    document.documentElement.style.setProperty('--ebb-anno-h', h + 'px');
  }
  function syncStuck() {
    var hdr = $('.ebb-header');
    if (hdr) hdr.classList.toggle('stuck', window.scrollY > 8);
  }
  safe('header', function () {
    measureAnno();
    syncStuck();
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { syncStuck(); ticking = false; });
    }, { passive: true });
    window.addEventListener('resize', measureAnno, { passive: true });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(measureAnno);
  });

  /* ══════════ ANNOUNCEMENT ROTATOR ══════════ */
  var annoTimer;
  function initAnno() {
    clearInterval(annoTimer);
    var track = $('.ebb-anno .anno-track');
    if (!track) return;
    var items = $$('.anno-item', track);
    if (items.length < 2) return;
    var i = items.findIndex ? items.findIndex(function (el) { return el.classList.contains('is-on'); }) : 0;
    if (i < 0) i = 0;
    // data-speed is milliseconds. Tolerate a seconds-style value (an older
    // published section stored "4"), and treat 0 as "no auto-rotation".
    var speed = parseInt(track.getAttribute('data-speed'), 10);
    if (isNaN(speed)) speed = 4200;
    if (speed > 0 && speed < 100) speed = speed * 1000;
    if (speed > 0 && speed < 1200) speed = 1200;
    function show(n) {
      i = (n + items.length) % items.length;
      items.forEach(function (el, k) { el.classList.toggle('is-on', k === i); });
    }
    function cycle() {
      clearInterval(annoTimer);
      if (!reduced && speed > 0) annoTimer = setInterval(function () { show(i + 1); }, speed);
    }
    track.__ebbAnno = { next: function () { show(i + 1); cycle(); }, prev: function () { show(i - 1); cycle(); } };
    show(i);
    cycle();
  }
  on('click', '[data-anno-next],[data-anno-prev]', function (e, t) {
    var track = $('.ebb-anno .anno-track');
    if (!track || !track.__ebbAnno) return;
    if (t.hasAttribute('data-anno-next')) track.__ebbAnno.next(); else track.__ebbAnno.prev();
  });

  /* ══════════ SCRIM (shared by the menu + cart drawers) ══════════ */
  function scrim() {
    var el = $('.ebb-scrim');
    if (!el) {
      el = document.createElement('div');
      el.className = 'ebb-scrim';
      document.body.appendChild(el);
    }
    return el;
  }
  function lockBody(lock) {
    document.body.style.overflow = lock ? 'hidden' : '';
  }
  function anyOpen() {
    return !!($('.ebb-drawer.open') || $('.ebb-cartdrawer.open'));
  }
  function syncScrim() {
    var open = anyOpen();
    scrim().classList.toggle('on', open);
    lockBody(open);
  }

  /* ══════════ MOBILE MENU DRAWER ══════════ */
  function setMenu(open) {
    var d = $('.ebb-drawer');
    if (!d) return;
    d.classList.toggle('open', open);
    d.setAttribute('aria-hidden', String(!open));
    $$('[data-ebb-burger]').forEach(function (b) { b.setAttribute('aria-expanded', String(open)); });
    syncScrim();
    if (open) {
      var first = d.querySelector('a, button');
      if (first) first.focus();
    }
  }
  on('click', '[data-ebb-burger]', function (e) { e.preventDefault(); setMenu(!$('.ebb-drawer.open')); });
  on('click', '[data-ebb-menu-close]', function (e) { e.preventDefault(); setMenu(false); });
  on('click', '.ebb-drawer a', function () { setMenu(false); });

  /* ══════════ HEADER SEARCH ══════════ */
  on('click', '[data-ebb-search-toggle]', function (e) {
    e.preventDefault();
    var bar = $('.ebb-searchbar');
    if (!bar) return;
    var open = !bar.classList.contains('on');
    bar.classList.toggle('on', open);
    e.target.closest('[data-ebb-search-toggle]').setAttribute('aria-expanded', String(open));
    if (open) { var i = bar.querySelector('input'); if (i) i.focus(); }
  });

  function closeSearch() {
    var bar = $('.ebb-searchbar');
    if (!bar || !bar.classList.contains('on')) return false;
    bar.classList.remove('on');
    var t = $('[data-ebb-search-toggle]');
    if (t) { t.setAttribute('aria-expanded', 'false'); t.focus(); }
    return true;
  }
  on('click', '[data-ebb-search-close]', function (e) { e.preventDefault(); closeSearch(); });
  /* Escape is what people already press to dismiss an overlay, and the bar
     covers the page it was opened from */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeSearch();
  });

  /* ══════════ CART ══════════ */
  var cartBusy = false;

  function cartSections() {
    var names = ['ebb-cart-drawer', 'ebb-cart-count'];
    if ($('[data-ebb-cart-page]')) names.push('ebb-cart-page');
    return names.join(',');
  }

  function replaceFrom(html, selector) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector(selector);
    if (!fresh) return;
    $$(selector).forEach(function (old) {
      var clone = fresh.cloneNode(true);
      old.replaceWith(clone);
    });
  }

  function renderSections(sections) {
    if (!sections) return;
    if (sections['ebb-cart-drawer']) replaceFrom(sections['ebb-cart-drawer'], '[data-ebb-cart-inner]');
    if (sections['ebb-cart-count']) replaceFrom(sections['ebb-cart-count'], '[data-ebb-cart-count]');
    if (sections['ebb-cart-page']) replaceFrom(sections['ebb-cart-page'], '[data-ebb-cart-page]');
    animateGoal();
    safe('fbt', loadFbt);
    safe('goalfx', celebrateGoal);
    safe('freegift', applyFreeGift);
    safe('topper', applyTopper);
    document.dispatchEvent(new CustomEvent('ebb:cart:updated'));
  }

  function animateGoal() {
    /* `> i[data-w]`, not `i`. The bar holds the fill AND each tier marker's
       Font Awesome glyph; a descendant selector matched the glyph too, found
       no data-w on it, and wrote `width: 0%` inline onto the icon. An inline
       style outranks every stylesheet, so the truck could never be centred
       from CSS — it painted out of the side of its circle. */
    $$('.cart-goal-bar > i[data-w]').forEach(function (bar) {
      var w = bar.getAttribute('data-w') || '0%';
      bar.style.width = '0%';
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { bar.style.width = w; });
      });
    });
  }

  function openCart() {
    var d = $('.ebb-cartdrawer');
    if (!d) { window.location.href = routes.cart_url || '/cart'; return; }
    d.classList.add('open');
    d.setAttribute('aria-hidden', 'false');
    syncScrim();
    animateGoal();
    var close = d.querySelector('[data-ebb-cart-close]');
    if (close) close.focus();
  }
  function closeCart() {
    var d = $('.ebb-cartdrawer');
    if (!d) return;
    d.classList.remove('open');
    d.setAttribute('aria-hidden', 'true');
    syncScrim();
  }
  EBB.openCart = openCart;

  function cartError(msg) {
    var box = $('[data-ebb-cart-err]');
    if (box) { box.textContent = msg; box.hidden = false; }
    toast(msg, true);
  }

  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (d) { return { ok: r.ok, data: d }; });
    });
  }

  EBB.addToCart = function (payload, btn, opts) {
    opts = opts || {};
    if (cartBusy) return Promise.resolve(false);
    cartBusy = true;
    if (btn) { btn.classList.add('is-loading'); btn.setAttribute('aria-busy', 'true'); btn.disabled = true; }
    payload.sections = cartSections();
    payload.sections_url = window.location.pathname;
    return postJSON((routes.cart_add_url || '/cart/add') + '.js', payload)
      .then(function (res) {
        if (!res.ok) {
          cartError((res.data && (res.data.description || res.data.message)) || 'Sorry, that could not be added.');
          return false;
        }
        renderSections(res.data.sections);
        if (btn) {
          btn.classList.remove('is-loading');
          btn.classList.add('is-done');
          setTimeout(function () { btn.classList.remove('is-done'); }, 1400);
        }
        if (!opts.silent) openCart();
        return true;
      })
      .catch(function () {
        cartError('Network hiccup — taking you to the cart instead.');
        return false;
      })
      .then(function (ok) {
        cartBusy = false;
        if (btn) { btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy'); btn.disabled = false; }
        return ok;
      });
  };

  EBB.changeLine = function (key, qty) {
    if (cartBusy) return Promise.resolve(false);
    cartBusy = true;
    var d = $('.ebb-cartdrawer'); if (d) d.classList.add('is-busy');
    return postJSON((routes.cart_change_url || '/cart/change') + '.js', {
      id: key, quantity: qty, sections: cartSections(), sections_url: window.location.pathname
    }).then(function (res) {
      if (!res.ok) { cartError((res.data && res.data.description) || 'Could not update the cart.'); return false; }
      renderSections(res.data.sections);
      return true;
    }).catch(function () {
      cartError('Could not reach the cart. Please try again.');
      return false;
    }).then(function (ok) {
      cartBusy = false;
      var dd = $('.ebb-cartdrawer'); if (dd) dd.classList.remove('is-busy');
      return ok;
    });
  };

  /* ══════════ CART CONVERSION STACK ══════════ */

  /* frequently bought together — the recommendations object is empty on a
     normal render, so fetch the section once per cart state */
  var fbtCache = null;
  function loadFbt() {
    $$('[data-ebb-fbt]').forEach(function (slot) {
      var pid = slot.getAttribute('data-product');
      var base = slot.getAttribute('data-url') || '/recommendations/products';
      if (!pid) { slot.innerHTML = ''; return; }
      if (fbtCache && fbtCache.pid === pid) { slot.innerHTML = fbtCache.html; return; }
      var url = base + '?section_id=ebb-cart-recommendations&product_id=' + encodeURIComponent(pid) +
                '&intent=complementary&limit=6';
      fetch(url)
        .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-ebb-fbt-inner]');
          var markup = fresh ? fresh.innerHTML : '';
          fbtCache = { pid: pid, html: markup };
          $$('[data-ebb-fbt]').forEach(function (el) { el.innerHTML = markup; });
        })
        .catch(function () { /* the rail simply stays empty */ });
    });
  }

  /* goal ladder — celebrate the first time a tier is crossed */
  function celebrateGoal() {
    var goal = $('[data-ebb-goal]');
    if (!goal) return;
    var reached = parseInt(goal.getAttribute('data-reached'), 10) || 0;
    var seen = parseInt(sessionStorage.getItem('ebb:goal:reached') || '0', 10);
    if (reached > seen) {
      goal.classList.add('is-unlocked');
      setTimeout(function () { goal.classList.remove('is-unlocked'); }, 1400);
      if (goal.hasAttribute('data-confetti') && !reduced) burstConfetti();
    }
    sessionStorage.setItem('ebb:goal:reached', String(reached));
  }

  function burstConfetti() {
    var run = function () {
      if (!window.confetti) return;
      var host = $('.ebb-cartdrawer.open') || $('[data-ebb-cart-page]');
      if (!host) return;
      var canvas = $('.ebb-confetti') || (function () {
        var c = document.createElement('canvas');
        c.className = 'ebb-confetti';
        host.appendChild(c);
        return c;
      })();
      try {
        var shoot = window.confetti.create(canvas, { resize: true, useWorker: true });
        shoot({ particleCount: 70, spread: 68, startVelocity: 32, origin: { y: 0.35 },
                colors: ['#D4C4D9', '#6A5679', '#6A7B68', '#C89A3C'], disableForReducedMotion: true });
      } catch (e) { /* confetti is decoration — never let it break the cart */ }
    };
    if (window.confetti) return run();
    if (document.querySelector('script[data-ebb-confetti]')) return;
    var src = (document.querySelector('link[href*="ebb-base.css"]') || {}).href || '';
    var tag = document.createElement('script');
    tag.setAttribute('data-ebb-confetti', '');
    tag.src = src.replace(/ebb-base\.css.*$/, 'vendor-confetti.min.js');
    tag.onload = run;
    document.head.appendChild(tag);
  }

  /* free topper — record the entitlement on the cart itself.

     The topper is packed by hand, so it is neither a line item nor a discount
     and nothing would otherwise reach the order. Writing a cart attribute is
     the same route an engraving note takes: it survives to the order, shows in
     admin under Additional details, and can be printed on the packing slip.

     Liquid does the counting (only it can see collection membership) and this
     only syncs the answer, so the browser never has to guess which lines are
     treats. Writes only on a real change, so it cannot loop against the cart
     re-render it triggers. */
  /* free topper — record the entitlement so it reaches the order.

     Written as a LINE ITEM PROPERTY, because that is the only thing Shopify
     renders in checkout; a cart attribute is metadata and never shows there.

     Exactly ONE cart write per pass, on purpose. Changing a line's properties
     changes its line key, so a second queued write would be aiming at a key
     that no longer exists. Each write re-renders the cart, Liquid recomputes
     the rule, and the next pass does the next step — which converges in at
     most two passes and cannot act on a stale key. */
  var topperBusy = false;
  var topperOps = 0;

  function topperParse(raw) {
    try { return JSON.parse(raw || '{}') || {}; } catch (e) { return {}; }
  }

  function applyTopper() {
    if (topperBusy || cartBusy) return;
    var rule = $('[data-ebb-topper-rule]');
    if (!rule) return;
    if (topperOps > 6) return;            /* belt and braces against a write that never settles */

    var value = rule.getAttribute('data-value') || '';
    var useLine = rule.getAttribute('data-use-line') === 'true';
    var useAttr = rule.getAttribute('data-use-attr') === 'true';

    /* ── 1 · the line item property ───────────────────────────────────── */
    var prop = rule.getAttribute('data-prop-name') || 'Free topper';
    var wantLine = rule.getAttribute('data-want-line') || '';
    var hasLine = rule.getAttribute('data-has-line') || '';
    var hasValue = rule.getAttribute('data-has-value') || '';

    /* Strip runs even when line recording is switched off, otherwise flipping
       the setting to "order note" would strand the property on every cart that
       already had one. Same reasoning as the disabled case: turning something
       off has to clean up after itself. */
    if (hasLine && (!useLine || !value || hasLine !== wantLine || hasValue !== value)) {
      var strip = topperParse(rule.getAttribute('data-has-props'));
      delete strip[prop];
      return topperChange(hasLine, strip);
    }
    if (useLine && value && wantLine && hasLine !== wantLine) {
      var add = topperParse(rule.getAttribute('data-want-props'));
      add[prop] = value;                  /* merge, never replace — other properties survive */
      return topperChange(wantLine, add);
    }

    /* ── 2 · the order attribute (optional, and cleans up after itself) ── */
    var name = rule.getAttribute('data-attribute') || 'Free topper';
    var current = rule.getAttribute('data-current') || '';
    var staleRaw = rule.getAttribute('data-stale') || '';
    var stale = staleRaw ? staleRaw.split('~|~') : [];
    var attrs = {};
    for (var i = 0; i < stale.length; i++) {
      if (stale[i]) attrs[stale[i]] = '';   /* '' is how the Cart API deletes one */
    }
    if (useAttr && value !== current) attrs[name] = value;
    if (!Object.keys(attrs).length) return; /* already correct — no write on a re-render */

    topperBusy = true; topperOps++;
    postJSON('/cart/update.js', {
      attributes: attrs, sections: cartSections(), sections_url: window.location.pathname
    })
      .then(function (res) { if (res && res.ok && res.data && res.data.sections) renderSections(res.data.sections); })
      .catch(function () { /* the promise on the bundle card stands either way */ })
      .then(function () { topperBusy = false; });
  }

  function topperChange(key, properties) {
    topperBusy = true; topperOps++;
    return postJSON('/cart/change.js', {
      id: key, properties: properties,
      sections: cartSections(), sections_url: window.location.pathname
    })
      .then(function (res) { if (res && res.ok && res.data && res.data.sections) renderSections(res.data.sections); })
      .catch(function () {})
      .then(function () { topperBusy = false; });
  }

  /* free gift — add once the qualifying subtotal (which EXCLUDES the gift's
     own line) crosses the threshold, remove when it drops back under.
     A shopper who removes it manually is not overruled for the session. */
  var giftBusy = false;
  function applyFreeGift() {
    if (giftBusy || cartBusy) return;
    var rule = $('[data-ebb-gift-rule]');
    if (!rule) return;
    var threshold = parseInt(rule.getAttribute('data-threshold'), 10) || 0;
    var subtotal = parseInt(rule.getAttribute('data-subtotal'), 10) || 0;
    var key = rule.getAttribute('data-line-key') || '';
    var variant = rule.getAttribute('data-variant');
    var available = rule.getAttribute('data-available') === 'true';
    if (!threshold || !variant) return;
    var qualifies = subtotal >= threshold;

    if (qualifies && !key && available && sessionStorage.getItem('ebb:gift:declined') !== '1') {
      giftBusy = true;
      EBB.addToCart({ id: variant, quantity: 1, properties: { _free_gift: 'true' } }, null, { silent: true })
        .then(function () { giftBusy = false; });
    } else if (!qualifies && key) {
      giftBusy = true;
      EBB.changeLine(key, 0).then(function () { giftBusy = false; });
    }
  }
  /* remembering a manual removal keeps the gift from bouncing back */
  on('click', '[data-line-remove]', function (e, t) {
    var rule = $('[data-ebb-gift-rule]');
    if (rule && rule.getAttribute('data-line-key') === t.getAttribute('data-line-remove')) {
      sessionStorage.setItem('ebb:gift:declined', '1');
    }
  });

  /* gift wrapping — one tap on, one tap off */
  document.addEventListener('change', function (e) {
    var box = e.target.closest ? e.target.closest('[data-ebb-gift]') : null;
    if (!box) return;
    var wrap = box.closest('.cart-gift');
    if (wrap) wrap.classList.add('is-busy');
    if (box.checked) {
      EBB.addToCart({ id: box.getAttribute('data-variant'), quantity: 1 }, null, { silent: true });
    } else {
      var key = box.getAttribute('data-line-key');
      if (key) EBB.changeLine(key, 0);
    }
  });

  /* ══════════ QUICK ADD ══════════════════════════════════════════════════
     One button behaviour for every add-on card on the site.

     A card cannot know whether its product needs a choice without shipping all
     its variants into the page, so it ships none: the click fetches
     /products/<handle>.js, and only opens the picker when the product actually
     has more than one purchasable variant. Single-variant products add
     straight from the card with no dialog at all, which is the common case.

     The button keeps a real href to the product page, so with JS off — or if
     the fetch fails — it still does something useful instead of nothing. */
  var qaddState = { variants: [], product: null, chosen: [], trigger: null };
  var qaddCache = {};

  function qaddEl() { return $('[data-ebb-qadd]'); }

  function qaddOpen() {
    var box = qaddEl(); if (!box) return;
    box.hidden = false;
    document.documentElement.classList.add('ebb-noscroll');
    var first = box.querySelector('[data-qadd-opt]') || box.querySelector('[data-qadd-add]');
    if (first) first.focus();
  }

  function qaddClose() {
    var box = qaddEl(); if (!box) return;
    box.hidden = true;
    document.documentElement.classList.remove('ebb-noscroll');
    if (qaddState.trigger && qaddState.trigger.focus) qaddState.trigger.focus();
    qaddState.trigger = null;
  }

  /* the variant whose options match every current choice */
  function qaddMatch() {
    for (var i = 0; i < qaddState.variants.length; i++) {
      var v = qaddState.variants[i], ok = true;
      for (var k = 0; k < qaddState.chosen.length; k++) {
        if (String(v.options[k]) !== String(qaddState.chosen[k])) { ok = false; break; }
      }
      if (ok) return v;
    }
    return null;
  }

  function qaddPaint() {
    var box = qaddEl(); if (!box) return;
    var v = qaddMatch();
    var priceEl = $('[data-qadd-price]', box);
    var addBtn = $('[data-qadd-add]', box);
    var label = $('[data-qadd-add-label]', box);
    var err = $('[data-qadd-err]', box);

    $$('[data-qadd-opt]', box).forEach(function (b) {
      var i = parseInt(b.getAttribute('data-opt-i'), 10);
      b.classList.toggle('on', String(qaddState.chosen[i]) === b.getAttribute('data-opt-v'));
      b.setAttribute('aria-checked', String(b.classList.contains('on')));
    });

    if (priceEl) priceEl.textContent = v ? money(v.price) : '';
    if (err) { err.hidden = true; err.textContent = ''; }

    if (!v) {
      if (label) label.textContent = 'Unavailable';
      if (addBtn) addBtn.disabled = true;
    } else if (!v.available) {
      if (label) label.textContent = 'Sold out';
      if (addBtn) addBtn.disabled = true;
    } else {
      if (label) label.textContent = 'Add to cart';
      if (addBtn) addBtn.disabled = false;
    }
  }

  function qaddRender(product, trigger) {
    var box = qaddEl(); if (!box) return;
    qaddState.product = product;
    qaddState.variants = product.variants || [];
    qaddState.trigger = trigger;

    /* start from the first variant that can actually be bought */
    var seed = qaddState.variants.filter(function (v) { return v.available; })[0] || qaddState.variants[0];
    qaddState.chosen = seed ? (seed.options || []).slice() : [];

    var t = $('[data-qadd-title]', box); if (t) t.textContent = product.title || '';
    var img = $('[data-qadd-img]', box);
    if (img) {
      img.innerHTML = '';
      var src = (seed && seed.featured_image && seed.featured_image.src) || product.featured_image;
      if (src) {
        var im = document.createElement('img');
        im.src = src; im.alt = ''; im.loading = 'lazy';
        img.appendChild(im);
      }
    }
    var view = $('[data-qadd-view]', box);
    if (view) view.setAttribute('href', '/products/' + product.handle);

    var wrap = $('[data-qadd-opts]', box);
    wrap.innerHTML = '';
    (product.options || []).forEach(function (opt, i) {
      var name = typeof opt === 'string' ? opt : opt.name;
      var values = (typeof opt === 'string' ? null : opt.values) ||
        qaddState.variants.map(function (v) { return v.options[i]; })
          .filter(function (val, k, arr) { return arr.indexOf(val) === k; });

      var row = document.createElement('div');
      row.className = 'qadd-row';
      var lab = document.createElement('span');
      lab.className = 'qadd-lbl'; lab.textContent = name;
      row.appendChild(lab);

      var group = document.createElement('div');
      group.className = 'qadd-pills';
      group.setAttribute('role', 'radiogroup');
      group.setAttribute('aria-label', name);

      values.forEach(function (val) {
        /* a value nothing purchasable uses is shown struck through rather than
           hidden, so the shopper can see the size exists and is just gone */
        var sellable = qaddState.variants.some(function (v) {
          return String(v.options[i]) === String(val) && v.available;
        });
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'qadd-opt' + (sellable ? '' : ' is-out');
        b.setAttribute('data-qadd-opt', '1');
        b.setAttribute('data-opt-i', i);
        b.setAttribute('data-opt-v', val);
        b.setAttribute('role', 'radio');
        b.textContent = val;
        group.appendChild(b);
      });
      row.appendChild(group);
      wrap.appendChild(row);
    });

    qaddPaint();
    qaddOpen();
  }

  function qaddFetch(handle) {
    if (qaddCache[handle]) return Promise.resolve(qaddCache[handle]);
    return fetch('/products/' + handle + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('http ' + r.status); return r.json(); })
      .then(function (p) { qaddCache[handle] = p; return p; });
  }

  on('click', '[data-ebb-quick-add]', function (e, t) {
    var handle = t.getAttribute('data-handle');
    if (!handle) return;                       /* nothing to work with — follow the href */
    e.preventDefault();
    if (t.classList.contains('is-loading')) return;

    var single = t.getAttribute('data-variant');
    if (single) {                              /* card already knows there is only one */
      EBB.addToCart({ id: single, quantity: 1 }, t);
      return;
    }

    t.classList.add('is-loading');
    t.setAttribute('aria-busy', 'true');
    qaddFetch(handle)
      .then(function (p) {
        var sellable = (p.variants || []).filter(function (v) { return v.available; });
        /* one way to buy it means no decision to make */
        if ((p.variants || []).length === 1 || sellable.length === 1) {
          var v = sellable[0] || p.variants[0];
          if (!v || !v.available) { toast('Sold out', true); return; }
          return EBB.addToCart({ id: v.id, quantity: 1 }, t);
        }
        qaddRender(p, t);
      })
      .catch(function () {
        window.location.href = '/products/' + handle;   /* worst case, the real page */
      })
      .then(function () {
        t.classList.remove('is-loading');
        t.removeAttribute('aria-busy');
      });
  });

  on('click', '[data-qadd-opt]', function (e, t) {
    e.preventDefault();
    qaddState.chosen[parseInt(t.getAttribute('data-opt-i'), 10)] = t.getAttribute('data-opt-v');
    qaddPaint();
  });

  on('click', '[data-qadd-add]', function (e, t) {
    e.preventDefault();
    var v = qaddMatch();
    if (!v || !v.available) return;
    EBB.addToCart({ id: v.id, quantity: 1 }, t).then(function (ok) {
      if (ok) qaddClose();
      else {
        var err = $('[data-qadd-err]', qaddEl());
        if (err) { err.textContent = 'That could not be added. Please try again.'; err.hidden = false; }
      }
    });
  });

  on('click', '[data-qadd-close]', function (e) { e.preventDefault(); qaddClose(); });
  document.addEventListener('keydown', function (e) {
    var box = qaddEl();
    if (e.key === 'Escape' && box && !box.hidden) qaddClose();
  });

  /* add-to-cart: every product form on the site goes through here */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.classList || !form.classList.contains('ebb-add-form')) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    var fd = new FormData(form);
    var items = { id: fd.get('id'), quantity: parseInt(fd.get('quantity'), 10) || 1 };
    if (!items.id) { toast('Choose an option first', true); return; }
    var props = {};
    fd.forEach(function (v, k) {
      var m = /^properties\[(.+)\]$/.exec(k);
      if (m && String(v).trim() !== '') props[m[1]] = v;
    });
    if (Object.keys(props).length) items.properties = props;
    var plan = fd.get('selling_plan');
    if (plan) items.selling_plan = plan;
    EBB.addToCart(items, btn).then(function (ok) {
      if (!ok && !navigator.onLine) form.submit();   /* no-JS style fallback */
    });
  });

  /* jump to the reviews. The href is a real anchor so it still works without
     JS; this only upgrades it, because the target we actually want is the
     Judge.me widget and an app block has no stable id to point an href at.
     Selectors are tried in order and the first one on the page wins, so a
     product without the app block still lands on the theme's own section. */
  on('click', '[data-ebb-reviews-link]', function (e, t) {
    var list = (t.getAttribute('data-targets') || '').split(',');
    var target = null;
    for (var i = 0; i < list.length && !target; i++) {
      var sel = list[i].trim();
      if (sel) { try { target = document.querySelector(sel); } catch (err) { target = null; } }
    }
    if (!target) return;                       /* let the href do its thing */
    e.preventDefault();
    /* scroll to the whole section, not the widget, so its heading is on screen */
    var sec = target.closest ? (target.closest('.shopify-section') || target) : target;
    sec.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
    if (history.replaceState && t.getAttribute('href')) {
      history.replaceState({}, '', t.getAttribute('href'));
    }
  });

  on('click', '[data-ebb-cart-open]', function (e) { e.preventDefault(); openCart(); });
  on('click', '[data-ebb-cart-close]', function (e) { e.preventDefault(); closeCart(); });
  on('click', '.ebb-scrim', function () { setMenu(false); closeCart(); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { setMenu(false); closeCart(); closeLightbox(); }
  });
  on('click', '[data-line-remove]', function (e, t) {
    e.preventDefault();
    EBB.changeLine(t.getAttribute('data-line-remove'), 0);
  });
  on('click', '[data-line-step]', function (e, t) {
    e.preventDefault();
    var wrap = t.closest('[data-line-key]');
    if (!wrap) return;
    var input = wrap.querySelector('[data-line-qty]');
    var next = Math.max(0, (parseInt(input.value, 10) || 1) + parseInt(t.getAttribute('data-line-step'), 10));
    input.value = next;
    EBB.changeLine(wrap.getAttribute('data-line-key'), next);
  });
  document.addEventListener('change', function (e) {
    var input = e.target.closest ? e.target.closest('[data-line-qty]') : null;
    if (!input) return;
    var wrap = input.closest('[data-line-key]');
    if (!wrap) return;
    var q = Math.max(0, parseInt(input.value, 10) || 0);
    input.value = q;
    EBB.changeLine(wrap.getAttribute('data-line-key'), q);
  });
  /* cart note — saved on blur, no extra button to miss */
  document.addEventListener('change', function (e) {
    var note = e.target.closest ? e.target.closest('[data-ebb-cart-note]') : null;
    if (!note) return;
    fetch((routes.cart_update_url || '/cart/update') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ note: note.value })
    }).then(function () { toast('Note saved'); }).catch(function () {});
  });

  /* ══════════ REVEAL ON SCROLL ══════════ */
  var io;
  function initReveal(root) {
    var els = $$('.rv:not(.in)', root || document);
    if (!els.length) return;
    if (!('IntersectionObserver' in window) || reduced) {
      els.forEach(function (el) { el.classList.add('in'); });
      return;
    }
    if (!io) {
      io = new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          if (el.parentElement && el.closest('[data-ebb-stagger]')) {
            var i = Array.prototype.indexOf.call(el.parentElement.children, el);
            el.style.transitionDelay = Math.min(i, 5) * 55 + 'ms';
          } else {
            el.style.transitionDelay = '0s';
          }
          el.classList.add('in');
          obs.unobserve(el);
        });
      }, { rootMargin: '0px 300% -8% 300%', threshold: 0.01 });
    }
    els.forEach(function (el) { io.observe(el); });
  }

  /* ══════════ MARQUEE (duplicate each track for a seamless loop) ══════════
     Two copies is the minimum a loop needs, but not always enough: the row
     only ever covers `width - oneTrack` at the seam, so on a wide screen a
     four-card track left a strip of bare background sweeping through. Count
     the copies from the measured width and tell CSS via --mq-n, which the
     keyframe divides by. Re-measures after images and fonts land, and on
     resize, because all three change the track width.

     The width is measured from the track's own CHILDREN, never from the
     track's box. A flex item's max-content contribution is taken from its
     content in WebKit, which ignores flex-basis, so Safari sized
     .marquee-track wrong in both directions. The feed track collapsed to
     just its gaps — 60px where the six cards span 1200 — because every
     child of a .fd card is absolutely positioned and so measures zero;
     ten clones then piled on top of each other 72px apart, which is the
     "repeating, overlapping images" the feed showed on iPhone. The review
     track went the other way, measuring 2603px against 1044 of cards and
     dragging a bare strip through frame. Summing the children is
     engine-proof, and pinning every copy to that width keeps the row's own
     width right even where the engine's intrinsic sizing is not. */
  var MQ_MAX = 10;

  /* what a track actually draws: its items, their margins, and the gaps */
  function trackContentWidth(track) {
    var kids = track.children, n = kids.length;
    if (!n) return 0;
    var gap = parseFloat(getComputedStyle(track).columnGap);
    if (!(gap >= 0)) gap = 0;                     // 'normal' means 0 on a flex box
    var w = gap * (n - 1);
    for (var i = 0; i < n; i++) {
      var ks = getComputedStyle(kids[i]);
      w += kids[i].getBoundingClientRect().width +
           (parseFloat(ks.marginLeft) || 0) + (parseFloat(ks.marginRight) || 0);
    }
    return w;
  }

  function fillMarquee(row) {
    var track = row.querySelector('.marquee-track');
    var box = row.parentElement;
    if (!track || !box) return;
    var one = trackContentWidth(track);
    var visible = box.clientWidth;
    if (!one || !visible) return;                 // not laid out yet

    /* pin every copy, the ones cloned on an earlier pass included, so the row
       is exactly n tracks plus n-1 gaps wide and the keyframe's -100%/--mq-n
       lands on the seam. Re-runs on every pass, so a breakpoint that changes
       the card width corrects itself. */
    $$('.marquee-track', row).forEach(function (t) { t.style.width = one + 'px'; });

    /* the DOM is the truth about how many copies exist: a data-mq-n left over
       from an earlier measurement can disagree with it after a section
       re-render, and then the seam lands mid-track */
    var have = $$('.marquee-track', row).length;
    var want = Math.max(2, Math.ceil((visible * 2) / one));
    if (want > MQ_MAX) want = MQ_MAX;

    if (want > have) {
      var frag = document.createDocumentFragment();
      for (var n = have; n < want; n++) {
        var clone = track.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');  // the reviews are read once
        $$('a,button', clone).forEach(function (el) { el.setAttribute('tabindex', '-1'); });
        $$('[data-shopify-editor-block],[id]', clone).forEach(function (el) {
          el.removeAttribute('data-shopify-editor-block');
          el.removeAttribute('id');
        });
        frag.appendChild(clone);
      }
      row.appendChild(frag);
    }

    /* publish the real count every time. A row that grew, a row that did not
       and a row measured for the first time all have to agree with the
       keyframe, or the loop does not meet itself. */
    var count = $$('.marquee-track', row).length;
    row.setAttribute('data-mq-n', count);
    row.style.setProperty('--mq-n', String(count));
  }

  function initMarquee(root) {
    var rows = $$('[data-mq]', root || document);
    if (!rows.length) return;
    rows.forEach(fillMarquee);

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () { $$('[data-mq]').forEach(fillMarquee); });
    }
    $$('img', root || document).forEach(function (img) {
      if (img.closest('[data-mq]') && !img.complete) {
        img.addEventListener('load', function () { $$('[data-mq]').forEach(fillMarquee); }, { once: true });
      }
    });
    if (initMarquee.bound) return;
    initMarquee.bound = true;
    var t = null;
    window.addEventListener('resize', function () {
      clearTimeout(t);
      t = setTimeout(function () { $$('[data-mq]').forEach(fillMarquee); }, 180);
    }, { passive: true });
  }

  /* ══════════ READ MORE / READ LESS ══════════
     Shared, because this was written once inside the product script and the
     story section needs the same thing. Pure progressive enhancement: the
     collapsed height lives in CSS, so a section can clamp at one breakpoint
     and not another, and the button hides itself wherever the text does not
     actually overflow — which is how "mobile only" is expressed without the
     JS knowing anything about breakpoints. */
  function initClamp(root) {
    $$('[data-ebb-clamp]:not([data-clamp-ready])', root || document).forEach(function (box) {
      box.setAttribute('data-clamp-ready', '1');
      var wrap = box.closest('[data-clamp-wrap]') || box.parentElement;
      var toggle = wrap ? wrap.querySelector('[data-clamp-toggle]') : null;
      if (!toggle) return;
      var userToggled = false;

      function label(open) {
        var l = toggle.querySelector('[data-clamp-label]');
        if (l) l.textContent = open ? (toggle.getAttribute('data-less') || 'Read less')
                                    : (toggle.getAttribute('data-more') || 'Read more');
        toggle.setAttribute('aria-expanded', String(open));
      }
      function measure() {
        if (userToggled) return;
        /* measure against the collapsed state, never the expanded one */
        box.classList.remove('is-expanded');
        var over = box.scrollHeight > box.clientHeight + 2;
        toggle.hidden = !over;
        if (!over) box.classList.add('is-expanded');
        label(false);
      }
      toggle.addEventListener('click', function (e) {
        e.preventDefault();
        userToggled = true;
        label(box.classList.toggle('is-expanded'));
      });
      measure();
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(measure);
      box.__ebbClampMeasure = measure;
    });

    if (initClamp.bound) return;
    initClamp.bound = true;
    var t = null;
    window.addEventListener('resize', function () {
      clearTimeout(t);
      /* crossing the breakpoint changes whether there is any clamp at all */
      t = setTimeout(function () {
        $$('[data-ebb-clamp]').forEach(function (b) {
          if (b.__ebbClampMeasure) b.__ebbClampMeasure();
        });
      }, 180);
    }, { passive: true });
  }
  EBB.initClamp = initClamp;

  /* ══════════ SCROLL RAIL (journal, and anything else that needs one) ══════════
     The rail scrolls natively; this only adds the arrows and the dots and
     keeps them honest. Pages are measured from the real scroll width, so the
     dot count follows the breakpoint instead of the block count — three-up on
     desktop and one-up on a phone are different numbers of pages over the
     same cards. Everything re-measures on resize and on image load. */
  function railPages(rail) {
    var page = rail.clientWidth;
    if (page < 1) return 1;
    return Math.max(1, Math.round(rail.scrollWidth / page));
  }

  function syncRail(root) {
    var rail = root.querySelector('[data-ebb-rail]');
    if (!rail) return;
    var prev = root.querySelector('[data-rail-prev]');
    var next = root.querySelector('[data-rail-next]');
    var dotsBox = root.querySelector('[data-rail-dots]');
    var nudge = root.querySelector('[data-rail-nudge]');
    var pages = railPages(rail);
    var overflow = rail.scrollWidth - rail.clientWidth > 2;

    if (prev) prev.hidden = !overflow;
    if (next) next.hidden = !overflow;
    /* the nudge is only honest while there is somewhere to swipe to, and only
       until the reader has worked that out for themselves */
    if (nudge) nudge.hidden = !overflow || root.hasAttribute('data-rail-used');

    if (dotsBox) {
      if (!overflow || pages < 2) {
        dotsBox.innerHTML = '';
      } else if (dotsBox.children.length !== pages) {
        dotsBox.innerHTML = '';
        for (var i = 0; i < pages; i++) {
          var d = document.createElement('button');
          d.type = 'button';
          d.className = 'jr-dot';
          d.setAttribute('role', 'tab');
          d.setAttribute('aria-label', 'Page ' + (i + 1) + ' of ' + pages);
          d.setAttribute('aria-selected', String(i === 0));
          d.addEventListener('click', (function (n) {
            return function () { rail.scrollTo({ left: n * rail.clientWidth, behavior: reduced ? 'auto' : 'smooth' }); };
          })(i));
          dotsBox.appendChild(d);
        }
      }
    }
    markRail(root, rail, prev, next, dotsBox);
  }

  function markRail(root, rail, prev, next, dotsBox) {
    var max = rail.scrollWidth - rail.clientWidth;
    var at = rail.scrollLeft;
    if (prev) prev.disabled = at <= 2;
    if (next) next.disabled = at >= max - 2;
    if (dotsBox && dotsBox.children.length) {
      var i = Math.round(at / Math.max(1, rail.clientWidth));
      i = Math.max(0, Math.min(dotsBox.children.length - 1, i));
      $$('button', dotsBox).forEach(function (d, k) { d.setAttribute('aria-selected', String(k === i)); });
    }
  }

  /* Auto-advance for rails that ask for it with data-rail-auto="<ms>".
     Deliberately self-limiting: it only runs while the rail actually overflows,
     so a layout that becomes a grid at a wider breakpoint stops on its own and
     never needs to know what a media query is. It also only runs while the rail
     is on screen, and yields the moment anyone touches it. */
  function autoRail(box, rail) {
    var ms = parseInt(box.getAttribute('data-rail-auto'), 10);
    if (!ms || reduced || !('IntersectionObserver' in window)) return;

    var timer = null, seen = false, held = false;

    function tick() {
      if (held || !seen) return;
      var max = rail.scrollWidth - rail.clientWidth;
      if (max <= 2) return;                       /* grid, not a rail — nothing to do */
      /* wrap only from the end itself. Advancing a full page at a time can
         overshoot before the last card has been shown — clamping to max first
         means the tail always gets its turn. */
      var atEnd = rail.scrollLeft >= max - 2;
      var next = Math.min(rail.scrollLeft + rail.clientWidth, max);
      rail.scrollTo({ left: atEnd ? 0 : next, behavior: 'smooth' });
    }
    function run() { stop(); timer = setInterval(tick, ms); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    /* hold while the reader is engaged, rather than fighting them for control */
    ['pointerdown', 'touchstart', 'mouseenter', 'focusin'].forEach(function (e) {
      rail.addEventListener(e, function () { held = true; stop(); }, { passive: true });
    });
    ['mouseleave', 'focusout'].forEach(function (e) {
      rail.addEventListener(e, function () { held = false; run(); }, { passive: true });
    });

    new IntersectionObserver(function (entries) {
      seen = entries[0].isIntersecting;
      if (seen && !held) run(); else stop();
    }, { threshold: 0.25 }).observe(box);
  }

  function initRails(root) {
    $$('[data-ebb-rail-root]:not([data-rail-ready])', root || document).forEach(function (box) {
      box.setAttribute('data-rail-ready', '1');
      var rail = box.querySelector('[data-ebb-rail]');
      if (!rail) return;
      var prev = box.querySelector('[data-rail-prev]');
      var next = box.querySelector('[data-rail-next]');
      var dotsBox = box.querySelector('[data-rail-dots]');
      var step = function (dir) {
        rail.scrollBy({ left: dir * rail.clientWidth, behavior: reduced ? 'auto' : 'smooth' });
      };
      if (prev) prev.addEventListener('click', function () { step(-1); });
      if (next) next.addEventListener('click', function () { step(1); });

      var ticking = false;
      rail.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          markRail(box, rail, prev, next, dotsBox);
          /* once it has actually moved, the hint has done its job */
          if (rail.scrollLeft > 8 && !box.hasAttribute('data-rail-used')) {
            box.setAttribute('data-rail-used', '1');
            var n = box.querySelector('[data-rail-nudge]');
            if (n) n.hidden = true;
          }
          ticking = false;
        });
      }, { passive: true });

      autoRail(box, rail);
      syncRail(box);
      /* a card's image landing changes the scroll width, and so does a resize */
      $$('img', rail).forEach(function (img) {
        if (!img.complete) img.addEventListener('load', function () { syncRail(box); }, { once: true });
      });
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { syncRail(box); });
    });

    if (initRails.bound) return;
    initRails.bound = true;
    var t = null;
    window.addEventListener('resize', function () {
      clearTimeout(t);
      t = setTimeout(function () { $$('[data-ebb-rail-root]').forEach(syncRail); }, 160);
    }, { passive: true });
  }

  /* ══════════ TRUST RAIL ══════════
     The trust strip as one continuous loop. It cannot reuse initMarquee:
     that clones the track exactly once, which is enough for the review
     wall's 336px cards but not for five small badges — one copy of those
     is narrower than a desktop viewport, so a half-width shift would drag
     bare background through frame. Count the copies from the measured
     width instead and hand the number to CSS as --mq-n; the keyframe is
     written as -100%/--mq-n, so the seam lands correctly at any count.
     Setting the attribute is also what arms the animation, so a rail that
     is never measured stays a plain static row. */
  var TRUST_RAIL_MAX = 12;                 // a stop, not a target

  function fillTrustRail(rail) {
    var row = rail.querySelector('.trust-mq-row');
    var track = row && row.querySelector('.trust-mq-track');
    if (!row || !track) return;

    var one = track.getBoundingClientRect().width;
    var visible = rail.clientWidth;
    if (!one || !visible) return;          // not laid out yet — a later pass retries

    /* twice the visible width guarantees the tail of the last copy is still
       off-screen when the first one comes back round */
    var have = parseInt(row.getAttribute('data-mq-n'), 10) || 1;
    var want = Math.max(2, Math.ceil((visible * 2) / one));
    if (want > TRUST_RAIL_MAX) want = TRUST_RAIL_MAX;
    if (want <= have) return;              // only ever tops up

    var frag = document.createDocumentFragment();
    for (var n = have; n < want; n++) {
      var clone = track.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');   // the badges are already read once
      $$('a,button', clone).forEach(function (el) { el.setAttribute('tabindex', '-1'); });
      /* a copy is scenery, not a block: leaving the editor attribute on it
         gives every badge several ids and makes selection in the theme
         editor land on whichever copy happens to be under the cursor */
      $$('[data-shopify-editor-block],[id]', clone).forEach(function (el) {
        el.removeAttribute('data-shopify-editor-block');
        el.removeAttribute('id');
      });
      frag.appendChild(clone);
    }
    row.appendChild(frag);
    row.setAttribute('data-mq-n', want);
    row.style.setProperty('--mq-n', want);
  }

  function initTrustRail(root) {
    var rails = $$('[data-ebb-trust-rail]', root || document);
    if (!rails.length) return;
    rails.forEach(fillTrustRail);

    /* Barlow is a webfont, so the first measurement can be taken against a
       fallback with different metrics. Re-measure once it lands. */
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () {
        $$('[data-ebb-trust-rail]').forEach(fillTrustRail);
      });
    }
    if (initTrustRail.bound) return;
    initTrustRail.bound = true;
    var t = null;
    window.addEventListener('resize', function () {
      clearTimeout(t);
      /* a wider window wants more copies; a narrower one already has enough,
         and fillTrustRail never removes any, so this cannot thrash */
      t = setTimeout(function () {
        $$('[data-ebb-trust-rail]').forEach(fillTrustRail);
      }, 180);
    });
  }

  /* ══════════ STAT COUNT-UP ══════════ */
  function initCounters(root) {
    var stats = $$('[data-count]:not([data-counted])', root || document);
    if (!stats.length || !('IntersectionObserver' in window)) {
      stats.forEach(function (el) {
        el.setAttribute('data-counted', '1');
        el.textContent = el.getAttribute('data-count') + (el.getAttribute('data-suffix') || '');
      });
      return;
    }
    var so = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        obs.unobserve(el);
        el.setAttribute('data-counted', '1');
        var target = parseFloat(el.getAttribute('data-count')) || 0;
        var suffix = el.getAttribute('data-suffix') || '';
        if (reduced || target === 0) { el.textContent = target + suffix; return; }
        var dur = 1100, t0 = performance.now();
        (function tick(now) {
          var p = Math.min((now - t0) / dur, 1);
          var eased = 1 - Math.pow(1 - p, 3);
          el.textContent = Math.round(target * eased) + suffix;
          if (p < 1) requestAnimationFrame(tick);
        })(t0);
      });
    }, { threshold: 0.4 });
    stats.forEach(function (el) { so.observe(el); });
  }

  /* ══════════ FILTER PILLS (best sellers) ══════════ */
  on('click', '[data-filter]', function (e, btn) {
    e.preventDefault();
    var group = btn.closest('[data-filter-group]');
    if (!group) return;
    var key = btn.getAttribute('data-filter');
    $$('[data-filter]', group).forEach(function (o) {
      var isOn = o === btn;
      o.classList.toggle('is-on', isOn);
      o.setAttribute('aria-pressed', String(isOn));
    });
    var targetSel = group.getAttribute('data-filter-group');
    var row = targetSel ? $(targetSel) : null;
    if (!row) return;
    applyFilter(row, btn);
    row.scrollLeft = 0;
  });

  /* Show the tab's products, capped at data-max, and point the row's "view
     all" at the tab the visitor is actually looking at. The cap is applied
     here rather than in Liquid because the row holds every tab's products at
     once — that is what lets switching tabs be instant instead of a reload. */
  function applyFilter(row, btn) {
    var key = btn.getAttribute('data-filter');
    /* a phone shows a two-up grid rather than a swipe rail, so it wants its
       own count — eight leaves a dangling row of one at two per line */
    var narrow = window.matchMedia('(max-width: 760px)').matches;
    var attr = narrow && row.getAttribute('data-max-mobile')
      ? 'data-max-mobile' : 'data-max';
    var max = parseInt(row.getAttribute(attr), 10);
    if (isNaN(max) || max < 1) max = Infinity;

    var shown = 0, matched = 0;
    $$('[data-cat]', row).forEach(function (card) {
      var cats = (card.getAttribute('data-cat') || '').split('|');
      var match = key === 'all' || cats.indexOf(key) !== -1;
      if (match) matched++;
      var visible = match && shown < max;
      if (visible) shown++;
      card.hidden = !visible;
    });

    var cta = row.parentElement && row.parentElement.querySelector('[data-prod-viewall]');
    if (!cta) return;
    var url = btn.getAttribute('data-url');
    if (url) cta.setAttribute('href', url);
    /* the count on the tab is the collection's real total; fall back to what
       is in the row so the label can never promise more than exists */
    /* data-count is taken — the stat count-up behaviour writes that attribute
       straight into textContent, which silently replaced every tab's label */
    var total = parseInt(btn.getAttribute('data-tab-count'), 10);
    if (isNaN(total) || total < matched) total = matched;
    var tpl = cta.getAttribute('data-template') || cta.textContent;
    cta.textContent = tpl.replace(/\{count\}/g, total).replace(/\{tab\}/g, btn.getAttribute('data-label') || '');
    cta.hidden = total <= shown && key !== 'all' && total <= max;
  }

  /* the row renders every tab's products, so the first paint must be capped
     too — otherwise all of them flash in before anyone clicks a tab */
  function refreshProdRow(row) {
    var group = document.querySelector('[data-filter-group="#' + row.id + '"]');
    var on = group && (group.querySelector('[data-filter].is-on') || group.querySelector('[data-filter]'));
    if (on) applyFilter(row, on);
  }

  function initProdRows(root) {
    $$('[data-prod-row]:not([data-prod-ready])', root || document).forEach(function (row) {
      row.setAttribute('data-prod-ready', '1');
      refreshProdRow(row);
    });
    if (initProdRows.bound) return;
    initProdRows.bound = true;
    var t = null;
    /* crossing 760px changes how many cards should show, so re-apply */
    window.addEventListener('resize', function () {
      clearTimeout(t);
      t = setTimeout(function () { $$('[data-prod-row]').forEach(refreshProdRow); }, 180);
    }, { passive: true });
  }

  /* ══════════ ACCORDIONS — one panel open at a time ══════════ */
  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (!d || d.tagName !== 'DETAILS' || !d.closest('[data-accordion]')) return;
    if (!d.open) return;
    $$('details', d.closest('[data-accordion]')).forEach(function (o) { if (o !== d) o.open = false; });
  }, true);

  /* ══════════ STICKY BARS (home hero + PDP) ══════════ */
  function initStickyBar(root) {
    $$('[data-sticky-bar]:not([data-sticky-ready])', root || document).forEach(function (bar) {
      bar.setAttribute('data-sticky-ready', '1');
      var watch = $(bar.getAttribute('data-sticky-watch') || '');
      var foot = $('.ebb-footer');
      if (!watch || !('IntersectionObserver' in window)) return;
      var past = false, atFoot = false;
      /* Publish the bar's height so anything anchored to the bottom of the
         viewport can clear it — the Smile.io launcher in particular, which is
         injected by the app and positions itself at bottom:40px with no idea
         this bar exists. Measured rather than hardcoded: the bar is a
         different height on a phone than on desktop. */
      function publishHeight() {
        var h = bar.classList.contains('on')
          ? Math.round(bar.getBoundingClientRect().height) : 0;
        document.documentElement.style.setProperty('--ebb-pdpbar-h', h + 'px');
      }
      function sync() {
        bar.classList.toggle('on', past && !atFoot);
        publishHeight();
      }
      window.addEventListener('resize', publishHeight, { passive: true });
      new IntersectionObserver(function (entries) {
        var en = entries[0];
        past = en.boundingClientRect.top < 0 && !en.isIntersecting;
        sync();
      }, { threshold: 0 }).observe(watch);
      if (foot) {
        new IntersectionObserver(function (entries) { atFoot = entries[0].isIntersecting; sync(); },
          { threshold: 0 }).observe(foot);
      }
    });
  }

  /* ══════════ HERO FLAVOUR PICKER ══════════ */
  function initHero(root) {
    $$('[data-ebb-hero]:not([data-hero-ready])', root || document).forEach(function (hero) {
      hero.setAttribute('data-hero-ready', '1');
      var chips = $$('.chip', hero);
      var imgs = $$('.stage-imgs img', hero);
      var glow = $('.stage-glow', hero);
      if (chips[0] && glow) glow.style.setProperty('--glow', chips[0].getAttribute('data-c') || '#C97B37');

      function pick(chip) {
        var i = parseInt(chip.getAttribute('data-i'), 10) || 0;
        chips.forEach(function (c) {
          var on = c === chip;
          c.classList.toggle('is-on', on);
          c.setAttribute('aria-selected', String(on));
        });
        imgs.forEach(function (img, n) { img.classList.toggle('is-on', n === i); });
        if (glow) glow.style.setProperty('--glow', chip.getAttribute('data-c') || '#C97B37');

        var flav = $('[data-hero-flav]', hero);
        if (flav) flav.textContent = chip.getAttribute('data-name') || '';
        var list = $('[data-hero-ings]', hero);
        if (list) {
          list.innerHTML = '';
          (chip.getAttribute('data-ing') || '').split(',').forEach(function (ing) {
            if (!ing.trim()) return;
            var li = document.createElement('li');
            li.textContent = ing.trim();
            list.appendChild(li);
          });
        }
        var priceEl = $('[data-hero-price]', hero);
        var price = chip.getAttribute('data-price') || '';
        if (priceEl && price) priceEl.textContent = price;
        var add = $('[data-hero-add]', hero);
        if (add) {
          var lbl = add.querySelector('[data-hero-add-label]');
          if (lbl) lbl.textContent = (add.getAttribute('data-label-prefix') || 'Add') + ' ' +
            (chip.getAttribute('data-name') || '') + (price ? ' — ' + price : '');
          var url = chip.getAttribute('data-url');
          if (url) add.setAttribute('href', url);
        }
        var idInput = $('[data-hero-variant]', hero);
        if (idInput) idInput.value = chip.getAttribute('data-variant') || '';
        var bar = $('[data-sticky-bar]');
        if (bar) {
          var bi = $('[data-sb-img]', bar), bn = $('[data-sb-name]', bar), bp = $('[data-sb-price]', bar);
          var src = chip.getAttribute('data-img');
          if (bi && src) bi.setAttribute('src', src);
          if (bn) bn.textContent = chip.getAttribute('data-name') || '';
          if (bp) bp.textContent = price + (chip.getAttribute('data-note') ? ' · ' + chip.getAttribute('data-note') : '');
          var ba = $('[data-sb-add]', bar);
          if (ba) {
            var burl = chip.getAttribute('data-url');
            if (burl) ba.setAttribute('href', burl);
            ba.setAttribute('data-variant', chip.getAttribute('data-variant') || '');
          }
        }
      }
      hero.addEventListener('click', function (e) {
        var chip = e.target.closest('.chip');
        if (chip) pick(chip);
      });
      hero.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        var chip = e.target.closest('.chip');
        if (!chip) return;
        e.preventDefault();
        var i = chips.indexOf(chip) + (e.key === 'ArrowRight' ? 1 : -1);
        var next = chips[(i + chips.length) % chips.length];
        next.focus(); pick(next);
      });
    });
  }

  /* ══════════ SHOPPABLE FEED LIGHTBOX ══════════ */
  var lbReturn = null, lbTimer = null;
  function closeLightbox() {
    var box = $('.ebb-fdbox');
    if (!box || box.hidden) return;
    box.classList.remove('on');
    lockBody(anyOpen());
    clearTimeout(lbTimer);
    lbTimer = setTimeout(function () {
      box.hidden = true;
      var m = $('.fdbox-media', box); if (m) m.innerHTML = '';
    }, 340);
    if (lbReturn && lbReturn.focus) lbReturn.focus();
  }
  on('click', '[data-feed-open]', function (e, btn) {
    e.preventDefault();
    var box = $('.ebb-fdbox');
    var card = btn.closest('.fd');
    if (!box || !card) return;
    var tpl = card.querySelector('[data-feed-payload]');
    var media = $('.fdbox-media', box), side = $('.fdbox-side', box);
    clearTimeout(lbTimer);
    var video = card.getAttribute('data-video');
    var img = card.getAttribute('data-img');
    media.innerHTML = video
      ? '<video src="' + video + '" poster="' + img + '" autoplay muted loop playsinline controls></video>'
      : '<img src="' + img + '" alt="">';
    side.innerHTML = tpl ? tpl.innerHTML : '';
    lbReturn = document.activeElement;
    box.hidden = false;
    requestAnimationFrame(function () { box.classList.add('on'); });
    lockBody(true);
    var x = $('.fdbox-x', box); if (x) x.focus();
  });
  on('click', '[data-feed-close]', function (e) { e.preventDefault(); closeLightbox(); });
  document.addEventListener('click', function (e) {
    var box = $('.ebb-fdbox');
    if (box && e.target === box) closeLightbox();
  });

  /* ══════════ NEWSLETTER inline validation (still a real Shopify form) ══════════ */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.classList || !form.classList.contains('ebb-nl-form')) return;
    var input = form.querySelector('input[type="email"]');
    var note = form.parentElement ? form.parentElement.querySelector('[data-nl-note]') : null;
    if (input && !/^[^\s@]+@[^\s@]+\.[a-z]{2,}$/i.test(input.value.trim())) {
      e.preventDefault();
      if (note) {
        note.classList.add('is-err');
        note.innerHTML = '<i class="fa-solid fa-circle-exclamation" aria-hidden="true"></i> Enter a valid email so we can send the code.';
      }
      input.focus();
    }
  });

  /* ══════════ COPY TO CLIPBOARD ══════════ */
  on('click', '[data-ebb-copy]', function (e, btn) {
    e.preventDefault();
    var target = document.querySelector(btn.getAttribute('data-ebb-copy'));
    if (!target) return;
    var text = (target.textContent || '').trim();
    var done = function () { toast('Copied'); };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(done, function () { toast('Press ⌘C to copy', true); });
    } else {
      var ta = document.createElement('textarea');
      ta.value = text; document.body.appendChild(ta); ta.select();
      try { document.execCommand('copy'); done(); } catch (err) { toast('Press ⌘C to copy', true); }
      document.body.removeChild(ta);
    }
  });

  /* ══════════ INIT / RE-INIT ══════════ */
  /* ══════════ MIX & MATCH PROGRESS ══════════ */
  /* Tells a shopper how close they are to the next tier. It has to exist because
     nothing else on the page can say so: every price label still reads the full
     price until the automatic discount fires in the cart, so without this the
     offer is invisible at exactly the moment someone is deciding.

     Tier quantities are read off the rendered cards rather than duplicated here,
     so editing a tier in the theme editor moves the bar with it. The cart is
     fetched rather than parsed out of the DOM because this section is usually on
     a collection page where no cart markup exists. */
  function mixMatch() {
    var strips = $$('[data-ebb-mixmatch]');
    if (!strips.length) return;

    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        strips.forEach(function (el) { paintMixMatch(el, cart); });
      })
      .catch(function () { /* leave the server-rendered resting copy in place */ });
  }

  function paintMixMatch(el, cart) {
    var scope = (el.getAttribute('data-ids') || '')
      .split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    if (!scope.length) return;

    var n = 0;
    (cart.items || []).forEach(function (i) {
      if (scope.indexOf(String(i.product_id)) !== -1) n += i.quantity;
    });

    var root = el.closest('section') || document;
    var tiers = $$('[data-mm-tier]', root)
      .map(function (t) {
        return {
          qty: parseInt(t.getAttribute('data-mm-tier'), 10) || 0,
          label: t.getAttribute('data-mm-label') || '',
        };
      })
      .filter(function (t) { return t.qty > 0; })
      .sort(function (a, b) { return a.qty - b.qty; });
    if (!tiers.length) return;

    var top = tiers[tiers.length - 1];
    var next = null;
    var reached = null;
    tiers.forEach(function (t) {
      if (n >= t.qty) reached = t;
      else if (!next) next = t;
    });

    var txt;
    if (n === 0) {
      txt = el.getAttribute('data-empty') || '';
    } else if (next) {
      txt = fillMM(el.getAttribute('data-next'), n, next.qty - n, next.label);
    } else {
      txt = fillMM(el.getAttribute('data-best'), n, 0, (reached || top).label);
    }

    var out = $('[data-mm-text]', el);
    if (out && txt) out.textContent = txt;

    /* Cap at the top tier so the bar reads "full", not 400%, once someone
       buys well past the last rung. */
    var fill = $('[data-mm-fill]', el);
    if (fill) {
      var pct = top.qty ? Math.min(100, Math.round((n / top.qty) * 100)) : 0;
      fill.style.width = pct + '%';
    }
    el.classList.toggle('is-done', !next && n > 0);
  }

  function fillMM(tpl, n, more, label) {
    if (!tpl) return '';
    return tpl
      .replace(/\[n\]/g, String(n))
      .replace(/\[more\]/g, String(more))
      .replace(/\[label\]/g, label);
  }

  function initAll(root) {
    safe('reveal', function () { initReveal(root); });
    safe('marquee', function () { initMarquee(root); });
    safe('trustrail', function () { initTrustRail(root); });
    safe('prodrows', function () { initProdRows(root); });
    safe('rails', function () { initRails(root); });
    safe('clamp', function () { initClamp(root); });
    safe('counters', function () { initCounters(root); });
    safe('sticky', function () { initStickyBar(root); });
    safe('hero', function () { initHero(root); });
    safe('anno', initAnno);
    safe('goal', animateGoal);
    safe('fbt', loadFbt);
    safe('freegift', applyFreeGift);
    safe('topper', applyTopper);
    safe('mixmatch', mixMatch);
    if (EBB.initProduct) safe('product', function () { EBB.initProduct(root); });
  }
  EBB.init = initAll;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }
  document.addEventListener('shopify:section:load', function (e) {
    measureAnno();
    initAll(e.target);
  });
  document.addEventListener('ebb:cart:updated', function () {
    safe('goal', animateGoal);
    safe('mixmatch', mixMatch);
  });
})();
